import { styled } from '@mui/material';
import TextField from '@mui/material/TextField';

const Input = styled(TextField)(({ theme }) => ({
  '& input': {
    backgroundColor: theme.palette.background.paper,
  },

  '& input:-webkit-autofill': {
    WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.default} inset`,
    WebkitTextFillColor: theme.palette.text.primary,
    caretColor: theme.palette.text.primary,
    borderRadius: 'inherit'
  },
  '& input:-webkit-autofill:focus': {
    WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.default} inset`,
    WebkitTextFillColor: theme.palette.text.primary,
    caretColor: theme.palette.text.primary,
    borderRadius: 'inherit'
  } 
}));

export default Input; 